module.exports = __webpack_public_path__ + "img/error-404.ae8ae6a3.png";